"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/spin/style/css");

var _spin = _interopRequireDefault(require("antd/es/spin"));

var _lodash = require("lodash");

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactInfiniteScroller = _interopRequireDefault(require("react-infinite-scroller"));

var _reactRedux = require("react-redux");

var _messages = require("../../redux/messages/messages.types");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _Username = _interopRequireDefault(require("../username/Username"));

var _ComposeMessage = _interopRequireDefault(require("./ComposeMessage"));

var _EmptyMessageList = _interopRequireDefault(require("./EmptyMessageList"));

var _Message = _interopRequireDefault(require("./Message"));

require("./thread.scss");

var _Toolbar = _interopRequireDefault(require("./Toolbar"));

var _clientWebsocketManager = _interopRequireDefault(require("../../redux/clientWebsocketManager"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class MessageList extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasMore: false,
      loading: false,
      pageSize: 16,
      pageNumber: 0,
      scrollToBottom: false
    };

    this.renderMessages = () => {
      const {
        response: {
          messages
        },
        userId
      } = this.props;

      let processedMessages = _lodash._.clone(messages);

      let i = 0;
      const messageCount = processedMessages.length;
      const tempMessages = [];
      processedMessages = processedMessages.sort((a, b) => (0, _moment.default)(a.createDate).unix() - (0, _moment.default)(b.createDate).unix());

      while (i < messageCount) {
        const previous = processedMessages[i - 1];
        const current = processedMessages[i];
        const next = processedMessages[i + 1];
        const isMine = current.userId === userId || current.fromAdmin;
        const currentMoment = (0, _moment.default)(current.createDate);
        let prevBySameAuthor = false;
        let nextBySameAuthor = false;
        let startsSequence = true;
        let endsSequence = true;
        let showTimestamp = true;

        if (previous) {
          const previousMoment = (0, _moment.default)(previous.createDate);

          const previousDuration = _moment.default.duration(currentMoment.diff(previousMoment));

          prevBySameAuthor = previous.userId === current.userId;

          if (prevBySameAuthor && previousDuration.as('hours') < 0.5) {
            startsSequence = false;
          }

          if (previousDuration.as('hours') < 0.5) {
            showTimestamp = false;
          }
        }

        if (next) {
          const nextMoment = (0, _moment.default)(next.createDate);

          const nextDuration = _moment.default.duration(nextMoment.diff(currentMoment));

          nextBySameAuthor = next.userId === current.userId;

          if (nextBySameAuthor && nextDuration.as('hours') < 0.5) {
            endsSequence = false;
          }
        }

        tempMessages.push( /*#__PURE__*/_react.default.createElement(_Message.default, {
          key: i,
          message: current,
          isMine: isMine,
          startsSequence: startsSequence,
          endsSequence: endsSequence,
          showTimestamp: showTimestamp
        }));
        i++;
      }

      return tempMessages;
    };

    this.handleInfiniteLoadMessages = page => {
      const {
        getMessagesStatus,
        getMessages
      } = this.props;
      const {
        hasMore,
        pageSize,
        pageNumber
      } = this.state;
      this.setState({
        loading: true
      });

      if (getMessagesStatus.isError || !hasMore) {
        this.setState({
          hasMore: false,
          loading: false
        });
        return;
      }

      getMessages(pageSize, pageNumber);
      this.setState({
        pageNumber: pageNumber + 1
      });
    };

    this.scrollToBottomMessageList = (smooth = false) => {
      if (this.messageListBottomRef.current) {
        this.messageListBottomRef.current.scrollIntoView(!smooth ? {
          block: 'end',
          inline: 'nearest'
        } : {
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest'
        });
        const messageList = document.getElementById('message-list');
        if (messageList) messageList.scrollTop += 60; // scrollIntoView doesn't quit scroll far enough
      }

      this.setState({
        scrollToBottom: false
      });
    };

    this.handleSubmit = input => {
      const {
        response,
        sendMessage,
        getMessages
      } = this.props;
      const {
        pageSize
      } = this.state;
      const {
        threadId
      } = response;
      sendMessage({
        threadId,
        body: input
      });
      getMessages(pageSize, 0);
      this.setState({
        scrollToBottom: true
      });
    };

    this.getMessages = () => {
      const {
        pageSize
      } = this.state;
      this.props.getMessages(pageSize, 0);
    };

    this.onScroll = event => {
      const {
        scrollToBottom
      } = this.state;
      const {
        scrollHeight,
        clientHeight,
        scrollTop
      } = event.target;
      const currentlyAtBottom = Math.round(scrollHeight - scrollTop) === clientHeight;

      if (currentlyAtBottom !== scrollToBottom) {
        this.setState({
          scrollToBottom: currentlyAtBottom
        });
      }
    };

    this.messageListBottomRef = /*#__PURE__*/_react.default.createRef();
  }

  componentDidMount() {
    const {
      response
    } = this.props;
    this.scrollToBottomMessageList();

    if (response && response.messages.length < response.messageCount) {
      this.setState({
        hasMore: true
      });
    }

    _clientWebsocketManager.default.registerObservingMessageThread(response.threadId);
  }

  componentWillUnmount() {
    const {
      response
    } = this.props;

    _clientWebsocketManager.default.unregisterObservingMessageThread(response.threadId);
  }

  componentDidUpdate(prevProps) {
    const {
      scrollToBottom
    } = this.state;
    const {
      response
    } = this.props;
    const {
      response: prevResponse
    } = prevProps;

    if (scrollToBottom && response.messages.length > prevResponse.messages.length) {
      this.scrollToBottomMessageList(true);
    }

    if (this.props.response.threadId !== prevProps.response.threadId) {
      _clientWebsocketManager.default.unregisterObservingMessageThread(prevProps.response.threadId);

      _clientWebsocketManager.default.registerObservingMessageThread(this.props.response.threadId);
    }
  }

  componentWillReceiveProps(prevProps) {
    const {
      hasMore,
      pageNumber,
      pageSize
    } = this.state;
    const {
      getMessagesStatus,
      response
    } = this.props;
    const {
      messages,
      messageCount
    } = response;

    if (hasMore) {
      if (getMessagesStatus.isSuccess) {
        this.setState({
          loading: false
        });
      }

      if (messages.length === messageCount) {
        this.setState({
          hasMore: false,
          loading: false
        });
      }

      if (pageNumber > Math.ceil(messageCount / pageSize)) {
        this.setState({
          pageNumber: 0
        });
      }
    } else if (messages && messages.length < messageCount) {
      this.setState({
        hasMore: true,
        loading: false
      });
    }
  }

  render() {
    const {
      response,
      getMessagesStatus,
      threads,
      isTypingIndicators
    } = this.props;
    const {
      loading,
      hasMore
    } = this.state;
    const {
      title
    } = response;

    const thread = _lodash._.find(threads, t => t.id === response.threadId);

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "message-column"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-message-column-toolbar"
    }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
      title: title,
      rightItems: [/*#__PURE__*/_react.default.createElement("span", {
        style: {
          marginRight: '25px'
        },
        key: thread === null || thread === void 0 ? void 0 : thread.participantId
      }, /*#__PURE__*/_react.default.createElement(_Username.default, {
        participantId: thread === null || thread === void 0 ? void 0 : thread.participantId
      }), ' ')]
    })), /*#__PURE__*/_react.default.createElement("div", {
      id: "message-list",
      className: "message-list",
      onScroll: this.onScroll
    }, /*#__PURE__*/_react.default.createElement(_reactInfiniteScroller.default, {
      initialLoad: false,
      pageStart: 0,
      loadMore: this.handleInfiniteLoadMessages,
      hasMore: hasMore && !loading && !getMessagesStatus.isLoading,
      useWindow: false,
      isReverse: true,
      threshold: 100
    }, hasMore && loading && /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-inbox-loading-container"
    }, /*#__PURE__*/_react.default.createElement(_spin.default, null)), /*#__PURE__*/_react.default.createElement("div", {
      className: "message-list-container"
    }, response ? this.renderMessages() : /*#__PURE__*/_react.default.createElement(_EmptyMessageList.default, null), /*#__PURE__*/_react.default.createElement("div", {
      ref: this.messageListBottomRef
    })))), /*#__PURE__*/_react.default.createElement(_ComposeMessage.default, {
      sendMessage: this.handleSubmit,
      getMessages: this.getMessages,
      threadId: response.threadId,
      isTypingIndicators: isTypingIndicators
    }));
  }

}

const mapDispatchToProps = dispatch => {
  return {
    sendMessage: args => dispatch(_messages.sendMessageAsync.request(args))
  };
};

const mapStateToProps = state => {
  return {
    getMessagesStatus: selectors.getMessagesStatus(state),
    threads: selectors.getMessageThreads(state),
    isTypingIndicators: selectors.getMessageIsTypingIndicators(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MessageList);

exports.default = _default;